__webpack_require__.p = "/wysiwyg-breakline-fix/referrals/";